// @flow
import { connect } from 'react-redux'

import { getCurrentRegion } from '@src/redux/selectors.js'

const select = state => ({
  currency: getCurrentRegion(state).currency,
})

export default connect(select)
